import { render, staticRenderFns } from "./re-new-order.vue?vue&type=template&id=080ced92&scoped=true"
import script from "./re-new-order.vue?vue&type=script&lang=js"
export * from "./re-new-order.vue?vue&type=script&lang=js"
import style0 from "./re-new-order.vue?vue&type=style&index=0&id=080ced92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ced92",
  null
  
)

export default component.exports